// SpiralPage.jsx
import React, { useState, useRef } from "react";
import Spiral3D from "../components/Spiral3D";

export default function SpiralPage() {
  // États entropie
  const [entropyUI, setEntropyUI] = useState(null);
  const [entropyDyn, setEntropyDyn] = useState(null);
  const [loadingUI, setLoadingUI] = useState(true);

  // Contrôles
  const [running, setRunning] = useState(true);
  const [chaos, setChaos] = useState(false);
  const [glow, setGlow] = useState(true);

  const [spiralSpeedPct, setSpiralSpeedPct] = useState(50);
  const [flashRatePct, setFlashRatePct] = useState(30);

  // 🔹 Bloom sliders
  const [bloomIntensity, setBloomIntensity] = useState(1.2);
  const [bloomRadius, setBloomRadius] = useState(0.6);
  const [bloomThreshold, setBloomThreshold] = useState(0.0);

  const canvasRef = useRef(null);

  // --- Entropie UI (curseurs) ---
  React.useEffect(() => {
    setLoadingUI(true);
    const controller = new AbortController();

    fetch("/api/geometry/spiral/entropy", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        chaos,
        glow,
        spiral_speed: spiralSpeedPct / 100,
        flash_rate: flashRatePct / 100,
      }),
      signal: controller.signal,
    })
      .then((r) => r.json())
      .then((data) => {
        if (typeof data.entropy === "number") setEntropyUI(data.entropy);
      })
      .catch(() => setEntropyUI(null))
      .finally(() => setLoadingUI(false));

    return () => controller.abort();
  }, [chaos, glow, spiralSpeedPct, flashRatePct]);

  // ⚡ Score total
  const entropyTotal =
    entropyUI !== null && entropyDyn !== null
      ? (entropyUI + entropyDyn).toFixed(4)
      : "--";

  return (
    <div
      className="page-container"
      style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: "20px" }}
    >
      <h1>Spiral Visualizer</h1>

      {/* Jauges */}
      <div style={{ display: "flex", gap: 36, marginBottom: 22 }}>
        <div className="card" style={{ minWidth: 170 }}>
          <h2>Entropie UI</h2>
          <div style={{ fontSize: "1.2rem", color: "#03dac6" }}>
            {loadingUI ? "⏳" : entropyUI !== null ? entropyUI.toFixed(4) : "❌"}
          </div>
        </div>
        <div className="card" style={{ minWidth: 170 }}>
          <h2 style={{ color: "#ff0266" }}>Entropie Dynamique</h2>
          <div style={{ fontSize: "1.2rem", color: "#ff0266" }}>
            {entropyDyn !== null ? entropyDyn.toFixed(4) : "⏳"}
          </div>
        </div>
        <div className="card" style={{ minWidth: 180 }}>
          <h2 style={{ color: "#bb86fc" }}>Score Total</h2>
          <div style={{ fontSize: "1.2rem", color: "#bb86fc" }}>
            {entropyTotal}
          </div>
        </div>
      </div>

      {/* Contrôles + Canvas */}
      <div style={{ display: "flex", alignItems: "center", gap: "28px" }}>
        {/* Contrôles */}
        <div style={{ display: "flex", flexDirection: "column", gap: "14px", minWidth: 260 }}>
          <button className="generate-button" onClick={() => setRunning((p) => !p)}>
            {running ? "⏸ Stop Animation" : "▶ Start Animation"}
          </button>

          <button
            onClick={() => setChaos((p) => !p)}
            style={{
              padding: "12px 18px",
              borderRadius: "6px",
              cursor: "pointer",
              backgroundColor: chaos ? "#ff0266" : "#03dac6",
              fontWeight: "bold",
            }}
          >
            {chaos ? "Désactiver Chaos" : "Activer Chaos"}
          </button>

          <button
            onClick={() => setGlow((p) => !p)}
            style={{
              padding: "12px 18px",
              borderRadius: "6px",
              cursor: "pointer",
              backgroundColor: glow ? "#ffd600" : "#666",
              fontWeight: "bold",
            }}
          >
            {glow ? "Désactiver Glow" : "Activer Glow"}
          </button>

          {/* Sliders classiques */}
          <div className="input-group">
            <label>Vitesse spirale : {spiralSpeedPct}%</label>
            <input type="range" min={0} max={100} value={spiralSpeedPct}
              onChange={(e) => setSpiralSpeedPct(Number(e.target.value))} />
          </div>

          <div className="input-group">
            <label>Flash : {flashRatePct}%</label>
            <input type="range" min={0} max={100} value={flashRatePct}
              onChange={(e) => setFlashRatePct(Number(e.target.value))} />
          </div>

          {/* 🔹 Sliders Bloom */}
          <div className="input-group">
            <label>Bloom Intensity : {bloomIntensity.toFixed(2)}</label>
            <input type="range" min={0} max={3} step={0.1}
              value={bloomIntensity} onChange={(e) => setBloomIntensity(Number(e.target.value))} />
          </div>

          <div className="input-group">
            <label>Bloom Radius : {bloomRadius.toFixed(2)}</label>
            <input type="range" min={0} max={2} step={0.1}
              value={bloomRadius} onChange={(e) => setBloomRadius(Number(e.target.value))} />
          </div>

          <div className="input-group">
            <label>Bloom Threshold : {bloomThreshold.toFixed(2)}</label>
            <input type="range" min={0} max={1} step={0.01}
              value={bloomThreshold} onChange={(e) => setBloomThreshold(Number(e.target.value))} />
          </div>
        </div>

        {/* Canvas */}
<Spiral3D
  ref={canvasRef}
  running={running}
  chaos={chaos}
  glow={glow}
  spiralSpeedPct={spiralSpeedPct}
  flashRatePct={flashRatePct}
  bloomIntensity={bloomIntensity}
  bloomRadius={bloomRadius}
  bloomThreshold={bloomThreshold}
  // 🔹 callback entropie dynamique branché au hook
  onEntropyUpdate={(val) => setEntropyDyn(val)}
/>

      </div>
    </div>
  );
}
